import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultValueLabelMulti: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.people.default-value-label-multi',
		defaultMessage: 'Default users',
		description: 'Label above picker for default value for people field in multi mode.',
	},
	defaultValueLabelSingle: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.people.default-value-label-single',
		defaultMessage: 'Default user',
		description: 'Label above picker for default value for people field in single mode.',
	},
	defaultValuePlaceholderMulti: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.people.default-value-placeholder-multi',
		defaultMessage: 'Choose users',
		description: 'Placeholder for default value control for people field in multi mode.',
	},
	defaultValuePlaceholderSingle: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.people.default-value-placeholder-single',
		defaultMessage: 'Choose a user',
		description: 'Placeholder for default value control for people field in single mode.',
	},
	defaultValueSingleDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.people.default-value-single-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default user',
		description: 'Tooltip shown when the default person field is disabled and cannot be edited',
	},
	defaultValueMultiDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.people.default-value-multi-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default users',
		description: 'Tooltip shown when the default people field is disabled and cannot be edited',
	},
});
